import { parseFlights } from '@augloop/workflow-flights';
export class LocalWorkflowContext {
    constructor(params) {
        this.model = params.model;
        this.clientMetadata = params.clientMetadata;
        this.site = params.site;
        this.getToken = params.getTokenCallback;
    }
    get flights() {
        var _a;
        (_a = this._flights) !== null && _a !== void 0 ? _a : (this._flights = parseFlights(this.clientMetadata.flights));
        return this._flights;
    }
    getToken(tokenType, cb) {
        return this.getToken(tokenType, cb);
    }
}
//# sourceMappingURL=local-workflow-context.js.map